import { render, staticRenderFns } from "./InstrumentName.vue?vue&type=template&id=1ef0dda3"
import script from "./InstrumentName.vue?vue&type=script&lang=ts"
export * from "./InstrumentName.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentName.vue?vue&type=style&index=0&id=1ef0dda3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports